import React, { useRef, useEffect } from 'react';
import logger from '../../../utils/logger';
import '../styles/NosotrosBioMercy.css';
import fondobajo from '../../../assets/nosotrosBioMercy/pexels-chokniti-khongchum-1197604-2280571 1.png';
import ojo from '../../../icons/ICONO OJO.gif';
import flecha from '../../../icons/ICONOS.gif';
import mano from '../../../assets/inovamos/mano.png';
import carro from '../../../assets/inovamos/carro.png';
import cabeza from '../../../assets/inovamos/cabeza.png';
import img1 from '../../../assets/productos/Cardiometabolica/BiodipinaLP.png';
import img2 from '../../../assets/productos/Cardiometabolica/Atorvastatin.png';
import img3 from '../../../assets/chambers Family (1).png';
import img4 from '../../../assets/HINALADOR.png';

const NosotrosBioMercy = ({ activeSection }) => {
  const visionRef = useRef(null);
  const quienesRef = useRef(null);

  // Scroll to the appropriate section based on activeSection prop - IGUAL QUE MEDICOSALDIA
  useEffect(() => {
    const timer = setTimeout(() => {
      if (activeSection === 'quienes' && quienesRef.current) {
        // console.log('NosotrosBioMercy: Scrolling to quienes section');
        quienesRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (activeSection === 'vision' && visionRef.current) {
        // console.log('NosotrosBioMercy: Scrolling to vision section');
        visionRef.current.scrollIntoView({ behavior: 'smooth' });
      } else {
        logger.debug(
          'NosotrosBioMercy: No valid section or ref found for scrolling',
          {
            activeSection,
            hasQuienesRef: !!quienesRef.current,
            hasVisionRef: !!visionRef.current,
          }
        );
      }
    }, 100); // 100ms delay to ensure DOM is rendered

    return () => clearTimeout(timer); // Cleanup timer
  }, [activeSection]);

  return (
    <div className="nosotros-container">
      {/* Banner Principal - QUIENES SOMOS SECTION */}
      <div className="banner-nosotros" ref={quienesRef} id="quienes-section">
        <div className="background-overlay"></div>

        {/* Logo BioMercy */}
        <div className="logo-container">
          <div className="biomercy-logo">
            <span className="bio-text">BIO</span>
            <span className="mercy-text">MERCY</span>
          </div>
        </div>

        {/* Texto principal */}
        <div className="texto-banner">
          <h2>
            <span className="rosa">Innovamos</span>
            <br />
            con <strong>propósito</strong>
          </h2>
          <p className="descripcion-biomercy">
            En <strong>BioMercy</strong> importamos, representamos y
            distribuimos medicamentos e insumos médicos innovadores, asequibles
            y de alta calidad. Nuestro compromiso no es innovar por tendencia,
            sino con un propósito: transformar la vida de los venezolanos a
            través de soluciones efectivas, éticas y humanas.
          </p>
        </div>

        {/* Productos flotantes */}
        <div className="productos-flotantes">
          <div className="producto producto-1">
            <div className="caja-producto-redonda biodipina">
              <div className="contenido-redondo">
                <img
                  src={img1}
                  alt="biodipina"
                  loading="lazy"
                  className="imagen-img1"
                />
              </div>
            </div>
          </div>

          <div className="producto producto-2">
            <div className="caja-producto-redonda losartan">
              <div className="contenido-redondo">
                <img
                  src={img3}
                  alt="chamber"
                  loading="lazy"
                  className="imagen-img3"
                />
              </div>
            </div>
          </div>

          <div className="producto producto-3">
            <div className="caja-producto-redonda metformina">
              <div className="contenido-redondo">
                <img
                  src={img2}
                  alt="atovastatin"
                  loading="lazy"
                  className="imagen-img2"
                />
              </div>
            </div>
          </div>

          <div className="producto producto-4">
            <div className="caja-producto-redonda atorvastatina">
              <div className="contenido-redondo">
                <img
                  src={img4}
                  alt="veriduo"
                  loading="lazy"
                  className="imagen-img4"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Sección de iconos con líneas punteadas */}
        <div className="iconos-seccion">
          <div className="icono-grupo">
            <div className="icono-wrapper asesoramiento">
              <img
                src={cabeza}
                alt="mano"
                loading="lazy"
                className="imagen-cabeza"
              />
            </div>
            <p className="icono-text">Asesoramiento</p>
          </div>

          <div className="linea-punteada"></div>

          <div className="icono-grupo">
            <div className="icono-wrapper responsabilidad">
              <img
                src={carro}
                alt="carro"
                loading="lazy"
                className="imagen-carro"
              />
            </div>
            <p className="icono-text">Responsabilidad</p>
          </div>

          <div className="linea-punteada"></div>

          <div className="icono-grupo">
            <div className="icono-wrapper innovacion">
              <img
                src={mano}
                alt="mano"
                loading="lazy"
                className="imagen-mano"
              />
            </div>
            <p className="icono-text">Innovamos</p>
          </div>
        </div>

        {/* Texto "Y seguimos innovando" */}
        <div className="seguimos-innovando">
          <h3>
            Y seguimos <span className="rosa">innovando.</span>
          </h3>
          {/* <div className="linea-decorativa"></div> */}
        </div>
      </div>

      {/* Misión y Visión - VISION SECTION */}
      <div
        className="mision-vision-nueva"
        ref={visionRef}
        id="mision-vision-section"
      >
        <div className="bloque-wrapper">
          <div className="bloque mision-bloque">
            <div className="contenido">
              <h4>Misión</h4>
              <p>
                Nuestra misión es mejorar la calidad de vida de millones de
                personas, ofreciéndoles soluciones integrales para su salud, así
                como contribuir al desarrollo social y económico del país a
                través de una gestión empresarial, ética, innovadora y
                responsable.
              </p>
            </div>
          </div>
        </div>

        {/* Líneas entre bloques */}
        <p className="linea-mision"></p>
        <p className="linea-vision"></p>

        {/* Caja para el ícono flecha */}
        <div className="icono1">
          <img src={flecha} alt="Ícono Misión" className="icono1-flecha" />
        </div>

        <div className="bloque-wrapper">
          <div className="bloque vision-bloque">
            <div className="contenido">
              <h4>Visión</h4>
              <p>
                Ser reconocidos como líder en el mercado farmacéutico venezolano
                gracias a la calidad de nuestros productos, innovación y
                compromiso social. Nos esforzamos por ampliar nuestra presencia
                en el mercado nacional e internacional con el apoyo de personas
                altamente calificadas y dedicadas.
              </p>
            </div>
          </div>
        </div>

        {/* Caja para el ícono ojo */}
        <div className="icono2">
          <img src={ojo} alt="Ícono Visión" className="icono2-ojo" />
        </div>
      </div>

      {/* Calidad */}
      <div className="calidad">
        <div className="calidad-banner">
          <img src={fondobajo} loading="lazy" alt="Calidad BioMercy" />
        </div>
        <p>
          Responsabilidad • <strong>Calidad</strong> • Innovación <br />
          Ofrecemos medicamentos que cumplen con los más altos estándares de{' '}
          <strong>calidad, seguridad y eficacia.</strong>
        </p>
      </div>
    </div>
  );
};

export default NosotrosBioMercy;
